import { client } from '@/lib/sanity';

/**
 * Fetch videos with nested data for thumbnails and resources.
 * @param limit Number of videos to fetch (default: 10)
 * @param filters Additional GROQ filters (default: published videos)
 * @param sortOrder Sorting order for the query
 */
export const fetchVideos = async (
  limit: number = 1000,
  filters: string = 'status == "published"',
  sortOrder: string = 'coalesce(metadata.uploadDate, _createdAt) desc'
) => {
  const query = `
    *[_type == "video" && status == 'published' && ${filters}] | order(${sortOrder}) [0...${limit}] {
      _id,
      title,
      thumbnailPortrait,
      thumbnailLandscape,
      vimeoMetadata,
      duration,
      slug,
      metadata,
      _createdAt,
      videoResource-> {
        _id,
        resourceItems[] {
          _key,
          vimeoMetadata {
            thumbnailUrl
          }
        }
      },
      videos[] {
        videoResource->{
          _id,
          resourceItems[]{
            _key,
            vimeoMetadata{
              thumbnailUrl
            }
          }
        },
        video->{
          _id,
          thumbnailPortrait,
          thumbnailLandscape,
          videoResource->{
            _id,
            resourceItems[]{
              _key,
              vimeoMetadata{
                thumbnailUrl
              }
            }
          }
        }
      }
    }
  `;

  try {
    const data = await client.fetch(query);
    // Debug: log the raw data to check for portrait thumbnails
    if (process.env.NODE_ENV === 'development') {
      console.log('[fetchVideos] Raw data:', JSON.stringify(data, null, 2));
    }
    return data;
  } catch (error) {
    console.error("Error fetching videos:", error);
    throw error;
  }
};

// TODO: Implement homepageFilters here as needed for index.tsx
export const homepageFilters = {
  newReleases: 'true', // All published videos, sorted by publishedAt desc
  cyclical: 'categories[]._ref in *[_type=="category" && group._ref=="Y7l1IhzX2fnyiano57goCw"]._id',
  alicesPicks: '"alice-s-picks" in tags[]->slug.current',
  series: 'categories[]._ref in *[_type=="category" && slug.current=="series" && group._ref=="Y7l1IhzX2fnyiano57d9pN"]._id',
  instructorInspo: '"instructor-inspo" in tags[]->slug.current',
}; 